import {PersonDto} from "../person/PersonApiClient";
import {ValidityIntervalDto} from "../time/ValidityIntervalDto";

export interface UserDto {
    id: number;
    login: string;
    identitySource: IdentitySource;
    person?: PersonDto;
    validityInterval?: ValidityIntervalDto;
    acl: UserAclDto;
}

export interface UserAclDto {
    canOpenFormSession: boolean;
}

export enum UserRoleType {
    SUBMITTER = "SUBMITTER",
    OPERATOR = "OPERATOR",
    ADMINISTRATOR = "ADMINISTRATOR",
    STATISTICS_READER = "STATISTICS_READER",
}

export enum IdentitySource {
    INTERNAL = "INTERNAL",
    NIA = "NIA",
}
